import { useMemo } from "react";
import { navMenu } from "../constants/mainSiteNavigation";
import { getSalesChannel, getUser, isProLoggedIn } from "../utils/jwt";

const useNavMenu = (removedMenu = []) => {
  const role = getSalesChannel() || "web";
  const isPro = isProLoggedIn();

  const { proAccountId, tier } = getUser() || {};
  const newNavMenu = useMemo(() => {
    return navMenu
      .filter((menu) => {
        if (menu.id === "becomepro" && role === "retail" && proAccountId) {
          return false;
        }
        if (removedMenu && removedMenu.includes(menu.id)) {
          return false;
        }
        return menu.access.includes(role);
      })
      .map((menu) => {
        if (menu.id === "more") {
          return {
            ...menu,
            menuItems: menu.menuItems.filter((item) =>
              item.access.includes(role)
            ),
          };
        }

        if (menu.id === "products") {
          return {
            ...menu,
            menuItems: menu.menuItems.filter((item) => {
              if (item.id === "peel") {
                return isPro
                  ? tier && tier !== "Tier 1"
                    ? false
                    : true
                  : false;
              }
              return true;
            }),
          };
        }
        return menu;
      });
  }, [role, proAccountId, tier, isPro, removedMenu]);

  return newNavMenu;
};

export default useNavMenu;
